const GetApp = () => {
  return (
    <div className="get-app">
      <div className="get-app__title">
        <h2>Get the app for your mobile</h2>
        <p>
          Ready to take your content to the next level? Download Hiko now and
          join a community of creators and listeners who live for sound.
        </p>
      </div>
      <div className="get-app__app-store-buttons">
        <a
          href="https://apps.apple.com/us/app/hiko-podcast-radio-music-voice/id1565934439"
          target="_blank"
          aria-label="Download on the App Store, opens in a new tab"
        >
          <button>
            <img
              loading="lazy"
              src="/assets/logos/app_stores/apple_store.svg"
              alt="apple store logo"
            />
          </button>
        </a>
        <a
          href="https://play.google.com/store/apps/details?gl=US&hl=en_US&id=etoba.radio"
          target="_blank"
          aria-label="Download on Google Play, opens in a new tab"
        >
          <button>
            <img
              loading="lazy"
              src="/assets/logos/app_stores/android_store.svg"
              alt="android store logo"
            />
          </button>
        </a>
      </div>
    </div>
  );
};

export default GetApp;
